import PropTypes from "prop-types"
import MetaTags from "react-meta-tags"
import React, { useEffect, useState } from "react"
import { Container } from "reactstrap"

import { isMobile } from "react-device-detect"

const Rsvp = props => {

  useEffect(() => {
    const loader = document.querySelector(".loader")
    loader.classList.add("loader--hide")
  }, [])

  return (
    <React.Fragment>
      <MetaTags>
        <title>Bajaj Life</title>
      </MetaTags>
      <div style={{ position: "relative", width: "100%" ,height:"100%"}}>
      <div
          style={{ position:"absolute",cursor: "pointer" }}
          onClick={() => {
            window.location.href = "/home"
          }}
          className="cardLoginrsvp"
        ></div>
        <img
          loading="lazy"
          src={
            isMobile
              ? // LoginMobImag
                "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Noora%20Health%20PWA%2FRSVP%20Page%20Phone.png?alt=media"
              : "https://firebasestorage.googleapis.com/v0/b/assets-f1765.firebasestorage.app/o/Noora%20Health%20PWA%2FRSVP%20Page%20PC.png?alt=media"
            // LoginLapImag
          }
          style={{  width: "100%" }}
          alt="Login"
        />
      
      </div>
    </React.Fragment>
  )
}

export default Rsvp
